import { render, staticRenderFns } from "./ResponseAlert.vue?vue&type=template&id=50c283d0&"
import script from "./ResponseAlert.vue?vue&type=script&lang=js&"
export * from "./ResponseAlert.vue?vue&type=script&lang=js&"
import style0 from "./ResponseAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
